import React from 'react';
import { Sidebar, useTranslation } from '@pascal/pascal-core';
import ResultWr from './resultWr';
import LimitsAndPayouts from './limitsAndPayouts';
import AdditionResultWr from './additionResultWr';
import { resultColumns, limitPayoutColumns, additionalResultTitle } from './columns';

export function PayoutsAndResultsContainer() {
  const t = useTranslation();
  return (
    <Sidebar
      position='left'
      results={ResultWr}
      additionalResults={AdditionResultWr}
      additionalTitle={t(additionalResultTitle)}
      limitsPayoutsWr={LimitsAndPayouts}
      resultsColumns={resultColumns}
      payoutsColumns={limitPayoutColumns}
      hasScrollToBottom
    />
  );
}
